import { z } from 'zod';

const TasksEventStreamMessageError = z.object({
  errors: z.array(z.string()),
});

const TasksEventStreamMessageSuccess = z.object({
  tasks: z.record(
    z.string(),
    z.array(
      z.object({
        id: z.string(),
        store_id: z.number(),
        market_id: z.string(),
        type: z.enum(['publication', 'recipe_state']),
        status: z.enum(['pending', 'started', 'success', 'failed']),
        message: z.string().nullable(),
        created_at: z.string(),
        updated_at: z.string(),
      }),
    ),
  ),
});

export const TasksEventStreamMessage = z.union([
  TasksEventStreamMessageError,
  TasksEventStreamMessageSuccess,
]);
